<template>
  <!-- <transition v-cloak  data-test-body-part-selector> -->
  <div class="modal-container" v-if="active">
    <div class="modal grid-x">
      <div class="cell close">
        <button
          class="close-button"
          title="Close (Esc) 1"
          type="button"
          data-test-body-part-selector-close
          @click="$emit('close')"
        >
          <span class="icon-cross" />
        </button>
      </div>
      <div class="cell">
        <h3 v-html="title" />
      </div>
      <slot />
    </div>
  </div>
  <!-- </transition> -->
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'BodyPartSelector',
  props: {
    active: {
      type: Boolean,
      default() {
        return false;
      }
    },
    title: {
      type: String,
      default() {
        return '';
      }
    }
  }
});
</script>

<style lang="scss" scoped>
@import 'src/styles/all';

.modal {
  position: absolute;
  border: 1px solid $disturber-color;
  padding: rem-calc(20);
  display: flex;
  align-items: left;
  min-width: 15rem;
  min-height: 10rem;
  background-color: $white;
  box-shadow: 1px 1px 10px 1px $medium-gray;
  z-index: 5000;
  border-radius: rem-calc(20);
  width: 80%;
  margin-left: 10%;
  margin-top: 30%;

  .close {
    margin: rem-calc(20);
    text-align: right;

    .icon-cross:before {
      color: $primary-color;
      margin-top: rem-calc(10);
    }
  }
}
</style>
